import "./MapConfigurations.html";
import "./MapConfigurations.scss";

import "./AddFunctionality/AddFunctionalityComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import MapConfigurationsComponentController from "./MapConfigurationsComponentController";

export default class MapConfigurationsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            isEditable: "=",
            isSidebarCollapsed: "<",
            map: "<",
            site: "=",
            siteEquipment: "=",
        };
        this.controller = MapConfigurationsComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/SelectedEquipment/MapConfigurations/MapConfigurations.html";
    }
}

module("mmManagePortal").component("mmMapConfigurations", new MapConfigurationsComponent());
